import React, { useState, useEffect } from "react";
import { postData } from "../../components/helpers/Data";
import Modal2 from "../../components/helpers/Modal2";
import { userAccessDetails } from "../../components/helpers/UserAccessDetails";
import { userSaveDetails } from "../../components/helpers/UserSaveDetails";

const UpdateEmail = () => {
  //save access log
  useEffect(() => {
    userAccessDetails(114);
  }, []);

  //create array for logs when renewing corp
  const logData = userSaveDetails(114);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [feedback, setFeedback] = useState([]);

  const updateEmail = (e) => {
    e.preventDefault();
    const frmData = new FormData(document.getElementById("update_email_form"));
    //append access log details
    frmData.append("user_id", logData[0]);
    frmData.append("accessed_item", logData[1]);
    frmData.append("browser_type", logData[2]);
    frmData.append("os_type", logData[3]);

    postData(frmData, "update_user_email")
      .then((data) => {
        if (data[0].includes("Error")) {
          console.log(data);
          setFeedback(["Error updating email!"]);
        } else {
          setFeedback(data);
        }
        setModalIsOpen(true);
      })
      .catch((error) => {
        console.log(error);
        setFeedback(["Error updating email. Contact Admin!"]);
        setModalIsOpen(true);
      });
  };

  const closeModal = () => {
    setModalIsOpen(false);
    if (feedback[0].includes("successfully")) {
      window.location.reload();
    }
  };
  return (
    <div>
      <div className="login_wrapper">
        <span className="text-danger text-center col-md-12">
          Enter your email identifier e.g john
        </span>
        <div className="animate form login_form">
          <section className="login_content">
            <form id="update_email_form" onSubmit={updateEmail}>
              <div>
                <input
                  type="text"
                  className="form-control"
                  required={true}
                  value={sessionStorage.getItem("mwerezi_mpos_username")}
                  name="user_name"
                  readOnly
                />
              </div>
              <div className="row">
                <input
                  type="text"
                  className="form-control col-md-6 mr-1"
                  placeholder="Email identifier  e.g  john.doe"
                  name="email"
                  id="email"
                  required={true}
                />
                <input
                  type="text"
                  className="form-control col-md-5"
                  placeholder="@demo-company.com"
                  readOnly
                />

                <p style={{ color: "red" }}></p>
              </div>
              <div>
                <button type="submit" className="btn btn-info form-control">
                  Update
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
      <Modal2
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
        body={
          <p className="h4 text-white font-weight-bold text-left">{feedback}</p>
        }
        background="#105878"
      />
    </div>
  );
};

export default UpdateEmail;
